import { track, getPageSource } from '@mc/track-event'

export const trackBadgeApplied = (categoryName: string) => {
  track('Navigation Badge Applied', {
    action: `Browse Category Dropdown:${categoryName}`,
    level: 'secondary',
    page_source: getPageSource(),
  })
}
